import { Alert } from '@mui/material';
import { loadStripe } from '@stripe/stripe-js';
import React from 'react'
import useBSSLogger from '../../../../hooks/useBSSLogger';
import __t from '../../../../lib/traduzioni';
import PayWithStripe from '../../../PayWithStripe';

const {logger} = useBSSLogger();

const Stripe = ({parametri, methods, modalita}) => {

    const pk = parametri?.PUBLICKEYSTRIPE?.valore ?? null;

    if(pk === null) {
        logger.error("chiave pubblica di stripe non fornita")
        return (
            <Alert severity='error'>
                {__t("stripenondisponibile")}
            </Alert>
        )
    }

    const stripePromise = loadStripe(pk);

    return (
        <>
            {/* <pre>{JSON.stringify(parametri, null, 2)}</pre> */}
            <PayWithStripe stripePromise={stripePromise} methods={methods} modalita={modalita} parametri={parametri} />            
        </>
    )
}

export default Stripe